import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ComponentsDashboardModule } from '../components/components-dashboard.module';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';

@Component({
  selector: 'app-globot-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MultiSelectModule,
    DropdownModule,
    ReactiveFormsModule,
    ComponentsDashboardModule,
    TooltipModule,
    CalendarModule,
  ],
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
})
export class GlobotDashboardComponent {}
